import { useEffect, useState } from "react";
import { closeModal, Modal, openModal } from "risa-oasis-ui_v2";
import { ModalId } from "../../../enums/modalId";
import type { RoleOption } from "../../../types";
import CustomRadioButton from "../../customRadioButton/customRadioButton";

const DEFAULT_ROLE_OPTIONS: RoleOption[] = [
  { value: "Admin", label: "Admin" },
  { value: "Member", label: "Member" },
];

interface UpdateUserRoleModalProps {
  isOpen: boolean;
  memberId: string;
  currentRole?: string;
  memberName?: string;
  onSave: (memberId: string, newRole: string) => Promise<void>;
  onClose: () => void;
  roleOptions?: RoleOption[];
}

const MODAL_ID = ModalId.UPDATE_USER_ROLE_MODAL;

const UpdateUserRoleModal = (props: UpdateUserRoleModalProps) => {
  const [selectedRole, setSelectedRole] = useState<string>("");
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    if (props.isOpen) {
      openModal(MODAL_ID);
      setSelectedRole("");
    } else {
      closeModal(MODAL_ID);
    }
  }, [props.isOpen]);

  const handleModalClose = () => {
    setSelectedRole("");
    props.onClose();
  };

  const handleSave = async () => {
    if (selectedRole === "") return;
    try {
      setIsUpdating(true);
      await props.onSave(props.memberId, selectedRole);
      handleModalClose();
    } catch (error) {
      handleModalClose();
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <Modal
      dialogId={MODAL_ID}
      onSave={handleSave}
      title={"Update User Role"}
      saveButtonText={isUpdating ? "Updating..." : "Update Role"}
      cancelText={"Cancel"}
      onClose={handleModalClose}
      disableSave={selectedRole === "" || isUpdating}
    >
      <div className="flex flex-col items-start gap-2 self-stretch">
        <div className="mb-2 text-small font-semiBold leading-small text-primaryGray-1">
          Select the user role
        </div>
        <div className="update-user-role-modal__radio-buttons flex flex-col gap-3">
          {(props.roleOptions ?? DEFAULT_ROLE_OPTIONS).map((option) => (
            <CustomRadioButton
              key={option.value}
              name="user-role"
              value={option.value}
              checked={selectedRole === option.value}
              label={option.label}
              onChange={() => setSelectedRole(option.value)}
            />
          ))}
        </div>
      </div>
    </Modal>
  );
};

export default UpdateUserRoleModal;
